import React from "react";
import { ViewfinderCircleIcon, TrashIcon } from "@heroicons/react/24/outline";

const ActivityCard = ({
  activity,
  onClick,
  isSelected,
  showDelete = false,
  onDelete,
  fillHeight = false,
}) => {
  const getBorderColor = () => {
    if (activity.type === "checkpoint") {
      return isSelected
        ? "border-l-4 border-l-brand-primary border-r border-r-brand-primary border-t border-t-brand-primary border-b border-b-brand-primary"
        : "border-l-4 border-l-brand-primary border-r border-r-gray-300 dark:border-r-gray-600 border-t border-t-gray-300 dark:border-t-gray-600 border-b border-b-gray-300 dark:border-b-gray-600";
    }
    if (activity.type === "tour") {
      return isSelected
        ? "border-l-4 border-l-brand-secondary border-r border-r-brand-secondary border-t border-t-brand-secondary border-b border-b-brand-secondary"
        : "border-l-4 border-l-brand-secondary border-r border-r-gray-300 dark:border-r-gray-600 border-t border-t-gray-300 dark:border-t-gray-600 border-b border-b-gray-300 dark:border-b-gray-600";
    }
    return "";
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onDelete) {
      onDelete(activity);
    }
  };

  const getCheckpointTypeDisplay = (type) => {
    switch (type) {
      case "NFC":
        return "NFC";
      case "Barcode":
      case "QR code":
        return "QR Code";
      case "Manual":
        return "Manual";
      default:
        return type;
    }
  };

  const hasSubtitle = activity.customer || activity.site;

  return (
    <div className={`group relative ${fillHeight ? "h-full" : "my-1"}`}>
      <div
        onClick={onClick}
        className={`w-full max-w-full overflow-hidden bg-white dark:bg-gray-800 rounded-md text-left pl-3 pr-2.5 py-1.5 cursor-pointer transition-all duration-200
        ${fillHeight ? "h-full" : ""} ${getBorderColor()}${
          isSelected ? " bg-brand-50 dark:bg-gray-700" : ""
        } hover:bg-gray-100 dark:hover:bg-gray-900`}
      >
        {/* Title + type badge on one line (time is encoded by position now) */}
        <div className="flex items-center gap-1.5 min-w-0">
          <h3
            className="truncate text-sm font-medium text-gray-700 dark:text-gray-200"
            title={activity.label}
          >
            {activity.label}
          </h3>

          {activity.type === "tour" && activity.checkpoints && (
            <span className="shrink-0 inline-flex items-center gap-1 whitespace-nowrap text-[11px] text-gray-400 dark:text-gray-500">
              <ViewfinderCircleIcon className="h-3.5 w-3.5 shrink-0" />
              {activity.checkpoints} checkpoints
            </span>
          )}
          {activity.type === "checkpoint" && activity.checkpoint_type && (
            <span className="shrink-0 text-[10px] text-gray-500 dark:text-gray-400 bg-gray-100 dark:bg-gray-700 px-1.5 py-0.5 rounded">
              {getCheckpointTypeDisplay(activity.checkpoint_type)}
            </span>
          )}
        </div>

        {/* Optional customer/site line (used in the activity picker) */}
        {hasSubtitle && (
          <div className="mt-0.5 text-xs text-gray-600 dark:text-gray-400 truncate">
            {activity.customer && activity.site
              ? `${activity.customer.name} • ${activity.site.name}`
              : activity.customer
                ? activity.customer.name
                : activity.site.name}
          </div>
        )}
      </div>

      {/* Delete — fades in on the right on hover */}
      {showDelete && (
        <button
          onClick={handleDelete}
          className="absolute right-1 top-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 p-1 rounded-full bg-white/80 dark:bg-gray-800/80"
          title="Delete activity"
          type="button"
        >
          <TrashIcon className="h-4 w-4 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors duration-150" />
        </button>
      )}
    </div>
  );
};

export { ActivityCard };
